export const LANGUAGE_KEY = 'LANGUAGE';

export const LANGUAGES: { code: string; label: string }[] = [
  { code: 'ru', label: 'RU' },
  { code: 'kk', label: 'KK' },
  { code: 'en', label: 'EN' },
];

const SUPPORTED = LANGUAGES.map((l) => l.code);

export const setStoredLanguage = (code: string) => {
  localStorage.setItem(LANGUAGE_KEY, code);
};

/**
 * Language to start i18n with: the operator's saved choice, otherwise a supported
 * match for the browser's preference, otherwise Russian.
 */
export const resolveInitialLanguage = (): string => {
  const stored = localStorage.getItem(LANGUAGE_KEY);
  if (stored && SUPPORTED.includes(stored)) {
    return stored;
  }

  const preferred = (navigator.languages ?? [navigator.language]).filter(Boolean);
  for (const tag of preferred) {
    const base = tag.split('-')[0].toLowerCase();
    if (SUPPORTED.includes(base)) {
      return base;
    }
  }

  return 'ru';
};
